<script setup lang="ts">
import { computed } from 'vue'
import { useMessagePreview } from '#entities/message'
import type { AlertMessage, AlertPing } from '../model/alert'
import AlertContentLayout from './alert-content-layout.vue'

const { alert } = defineProps<{ alert: AlertMessage | AlertPing }>()

const emit = defineEmits<{ 'link-click': [] }>()

const message = computed(() => alert.message)
const messagePreview = useMessagePreview(message, 'large')

const label = computed(() => {
  if (alert.type === 'ping') {
    return 'mentioned you:'
  }

  return 'sent you message:'
})
</script>

<template>
  <AlertContentLayout :alert="alert" @link-click="emit('link-click')">
    <template #label>{{ label }}</template>

    <template #content>
      {{ messagePreview }}
    </template>
  </AlertContentLayout>
</template>
